import { createSelector } from 'reselect';
import cloneDeep from 'lodash/cloneDeep';
import LocaleKeys from '../../../locales/keys';
import { AddressDataSelector, CurrentAddressesSelector } from '../../../reducers/selectors/customer.addresses.selectors';
import { AddressHelper, i18n, MetadataConstants, MetadataSelectors } from 'invision-core';
import { addressStateRegionProvinceValueOptionsForCountry } from '../../../reducers/helpers/customer.selectors.helpers';
import { GENERAL_STATUSES } from '../../shared/constants/general.status.constants';
import { UserSecurityAttributesSelector } from 'invision-core/src/components/session/session.selectors';
import { hasAdminAccess } from 'invision-core/src/components/security/permission.service';
import { ADDRESS_ACCESS } from '../../../security.attributes';
var NO_ADDRESSES = [];
export var MakePaymentStoreSelector = function MakePaymentStoreSelector(state) {
  return state.customercare.recoverableUiState.makePayment;
};
export var MakePaymentInstrumentSelector = createSelector([MakePaymentStoreSelector], function (makePaymentStore) {
  return makePaymentStore.paymentInstrument;
});
export var MakePaymentAddressesSelector = createSelector([CurrentAddressesSelector, UserSecurityAttributesSelector], function (addresses, userSecurityAttributes) {
  var popupAddresses = [];
  var hasAddressFullAccess = hasAdminAccess(userSecurityAttributes, ADDRESS_ACCESS);
  if (!addresses) {
    addresses = NO_ADDRESSES;
  }
  var blankBillingAddress = {
    Id: 0,
    Country: null,
    State: null
  };
  if (hasAddressFullAccess) {
    popupAddresses = [blankBillingAddress].concat(cloneDeep(addresses));
  } else {
    popupAddresses = cloneDeep(addresses);
  }
  return popupAddresses.filter(function (address) {
    return address.Status !== GENERAL_STATUSES.REMOVED;
  }).map(function (address) {
    address.dropDownString = address.Id === 0 ? i18n.translate(LocaleKeys.ADD_NEW) : AddressHelper.createBillingAddressString(address);
    return address;
  });
});
export var MakePaymentAddressSelector = createSelector([MakePaymentAddressesSelector, MakePaymentInstrumentSelector], function (makePaymentAddresses, makePaymentInstrument) {
  if (!makePaymentInstrument || !makePaymentInstrument.BillingAddress || !makePaymentAddresses.length) {
    return;
  }
  return makePaymentAddresses.find(function (address) {
    return address.Id === makePaymentInstrument.BillingAddress.Id;
  });
});
export var EditAddressPopupStateRegionProvinceValueOptions = createSelector([AddressDataSelector, MetadataSelectors.codes.MetadataCodeTypeSelector(MetadataConstants.codes.AddressCountry), MetadataSelectors.codes.MetadataCodeTypeSelector(MetadataConstants.codes.AddressStateProvinceRegion)], function (addressData, countryCodes, stateCodes) {
  if (!addressData || !addressData.address) {
    return null;
  }
  return addressStateRegionProvinceValueOptionsForCountry(addressData.address.Country, countryCodes, stateCodes);
});